// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1904":"35bf5e67","3362":"f2912076","6126":"4b21e67b","6915":"7c12abeb","8085":"459cf4b8","8330":"ed0baaef","8767":"2865d797","9821":"96728110"}[chunkId] + ".chunk.css";
};